import React, { useEffect, useState } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
const TOTAL_SLOTS = 1000;
const REMAINING = 728;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
/** Countdown resets to ~1h15m so the timer always shows urgency. */
function useCountdown(initialSeconds: number) {
  const [secs, setSecs] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setSecs(s => s <= 1 ? initialSeconds : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [initialSeconds]);
  return {
    h: Math.floor(secs / 3600),
    m: Math.floor(secs % 3600 / 60),
    s: secs % 60
  };
}
function TimeBox({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-54" data-mp="1w58ksoml54os">
      <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-[var(--pb-navy)] font-display text-3xl font-800 text-[var(--pb-lime)] tabular-nums" data-id="element-55" data-mp="6or3pdmxzcle">
        {pad(value)}
      </div>
      <span className="mt-1 text-[10px] font-600 uppercase tracking-wider text-white/50" data-id="element-56" data-mp="2jr9sqiqavbeo">
        {label}
      </span>
    </div>;
}
export function CountdownUrgency() {
  const {
    h,
    m,
    s
  } = useCountdown(75 * 60 + 12);
  const pct = Math.round(REMAINING / TOTAL_SLOTS * 100);
  return <div className="rounded-2xl border border-red-300/40 bg-[#251827]/95 p-4 shadow-lg shadow-black/20" data-id="element-57" data-mp="2sq556cjxthqf">
      <div className="flex items-center justify-center gap-2 text-red-200" data-id="element-58" data-mp="32hrkol3b62yz">
        <ClockIcon size={16} data-id="element-59" data-mp="32jvol317j1z9" />
        <span className="text-xs font-700 uppercase tracking-widest" data-id="element-60" data-mp="37gm49p93nvk5">
          Offer Ends Soon
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-61" data-mp="3cfp5eylylhmu">
        <TimeBox value={h} label="Hours" data-id="element-62" data-mp="3ghkbegeu4j6y" />
        <span className="font-display text-3xl font-800 text-white/55" data-id="element-63" data-mp="3gg96gd9nl5e9">:</span>
        <TimeBox value={m} label="Min" data-id="element-64" data-mp="1i2pngyu3wbce" />
        <span className="font-display text-3xl font-800 text-white/55" data-id="element-65" data-mp="1i3qwyyvh4ps0">:</span>
        <TimeBox value={s} label="Sec" data-id="element-66" data-mp="1m4ax8bbcg9id" />
      </div>

      <div className="mt-4" data-id="element-67" data-mp="2pef61lp8e81s">
        <div className="mb-1.5 flex items-center justify-between text-xs" data-id="element-68" data-mp="2pfhza0a10mkv">
          <span className="flex items-center gap-1.5 font-600 text-white/90" data-id="element-69" data-mp="2kfluvzxf2t4s">
            <UsersIcon size={13} className="text-[var(--pb-lime)]" data-id="element-70" data-mp="2khov1csaa2n8" />
            Spots Remaining
          </span>
          <span className="font-800 text-[var(--pb-lime)]" data-id="element-71" data-mp="2udruubznxp70">
            {REMAINING} / {TOTAL_SLOTS}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-white/15" data-id="element-72" data-mp="38c9fg0u9ulkp">
          <div className="h-full rounded-full bg-[var(--pb-lime)]" style={{
          width: `${pct}%`
        }} data-id="element-73" data-mp="33eq0sztnw6s8" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-white/75" data-id="element-74" data-mp="3i4x94mpyg9f7">
          Launch-price spots are going fast.
        </p>
      </div>
    </div>;
}